import { Component, Input } from '@angular/core';

import { statusPretendidoPretendido } from '../../cliente-analise-mercado-status-pretendido';
import { ClienteAnaliseMercadoStatusPretendidoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-badge-pill-pretendido',
    templateUrl: './cliente-analise-mercado-status-pretendido-badge-pill-pretendido.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-badge-pill-pretendido.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoBadgePillPretendidoComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusPretendidoPipe: ClienteAnaliseMercadoStatusPretendidoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusPretendidoPipe.transform(statusPretendidoPretendido.id);
    }
}
